import useTranslation from 'next-translate/useTranslation';

// Types
import type { Table } from '@tanstack/react-table';
import type { GroupGlobalTableContentProps } from '@/components/pages/analyze-group/tables/GroupGlobalTable/GroupGlobalTableContent';
import type { GroupGlobalTableConfigRowDataType } from '@/lib/analyticsGroup/tables/groupGlobalTableConfig.type';

// Utils
import faqUrl from '@/utils/urls/faqUrl';

// Lib
import { url_faq_group_comparative_table } from '@/lib/urls/faqUrls';

// Components
import Icon from '@/components/base/Icon';
import LinkBase from '@/components/base/LinkBase';
import ButtonExportTable from '@/components/pages/analyze-group/tables/GroupGlobalTable/ActionBar/ButtonExportTable';
import SelectTableColumns from '@/components/base/Table/CompoundTable/Actions/SelectTableColumns';

export type ActionBarProps = Pick<
    GroupGlobalTableContentProps,
    'setColumnVisibility' | 'periodSelected' | 'userDataFormat'
> & {
    table: Table<GroupGlobalTableConfigRowDataType>;
};

const ActionBar = ({
    table,
    periodSelected,
    userDataFormat,
    setColumnVisibility
}: ActionBarProps) => {
    const { t } = useTranslation();
    return (
        <div className="flex items-end justify-between">
            <div>
                <LinkBase
                    href={faqUrl(url_faq_group_comparative_table)}
                    target="_blank"
                    rel="help noopener noreferrer"
                    className="flex items-center space-x-2 text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                    <Icon icon="help" />
                    <span className="underline">
                        {t('analytics:table_comparative_group.faq_text')}
                    </span>
                </LinkBase>
            </div>
            <div className="flex items-center space-x-2">
                <div>
                    <SelectTableColumns
                        buttonText={t('analytics:table_comparative_group.table_settings')}
                        columns={table.getAllColumns()}
                        visibleColumns={table.getVisibleFlatColumns()}
                        setColumnVisibility={setColumnVisibility}
                    />
                </div>
                <ButtonExportTable
                    table={table}
                    userDataFormat={userDataFormat}
                    periodSelected={periodSelected}
                />
            </div>
        </div>
    );
};

export default ActionBar;
